import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import { useState, useCallback, useEffect } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix default marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png'
});

function InnerDraggableMarker({ position, setPosition }) {
    useMapEvents({
        click(e) {
            setPosition(e.latlng);
        }
    });

    if (!position) return null;

    return (
        <Marker
            position={position}
            draggable={true}
            eventHandlers={{
                dragend(e) {
                    const marker = e.target;
                    const newPosition = marker.getLatLng();
                    setPosition(newPosition);
                }
            }}
        />
    );
}

function parsePos(pos) {
    if (!pos) return null;
    if (Array.isArray(pos) && pos.length === 2) {
        const lat = Number(pos[0]);
        const lng = Number(pos[1]);
        if (isFinite(lat) && isFinite(lng)) return [lat, lng];
    }
    if (pos && typeof pos === 'object' && pos.lat !== undefined && pos.lng !== undefined) {
        const lat = Number(pos.lat);
        const lng = Number(pos.lng);
        if (isFinite(lat) && isFinite(lng)) return [lat, lng];
    }
    return null;
}

export default function LocationPicker({ setLatitude, setLongitude, fnMapLocation, Position }) {
    const defaultPos = [28.894957, 76.606140];
    const initial = parsePos(Position) || defaultPos;
    const [position, setPosition] = useState(initial);

    useEffect(() => {
        const parsed = parsePos(Position);
        if (parsed) {
            setPosition(parsed);
            if (setLatitude) setLatitude(parsed[0]);
            if (setLongitude) setLongitude(parsed[1]);
            if (fnMapLocation) fnMapLocation(parsed[0], parsed[1]);
        }
    }, [Position]);

    const handlePositionChange = useCallback((newPos) => {
        if (!newPos) return;
        const parsed = parsePos(newPos) || parsePos(Position);
        if (!parsed) return;
        setPosition(parsed);
        if (setLatitude) setLatitude(parsed[0]);
        if (setLongitude) setLongitude(parsed[1]);
        if (fnMapLocation) fnMapLocation(parsed[0], parsed[1]);
    }, [setLatitude, setLongitude, fnMapLocation, Position]);

    return (
        <div style={{ width: '100%', height: '400px', marginTop: '10px' }}>
            <MapContainer
                center={position}
                zoom={13}
                style={{ height: '100%', width: '100%' }}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='© OpenStreetMap contributors'
                />
                <InnerDraggableMarker
                    position={position}
                    setPosition={handlePositionChange}
                />
            </MapContainer>
        </div>
    );
}
